import { Image } from 'expo-image'
import { useEffect, useState } from 'react'
import { View, Platform, Text, ScrollView, TouchableOpacity } from 'react-native'
import theme from '../../../theme'
import * as Progress from 'react-native-progress'
import { MaterialCommunityIcons } from '@expo/vector-icons'
import { Card } from './CardComponent'
import { LineChartCard, ComparisonBarChart, SimpleDataBarChartCard, VerticalStackedBars } from './DotiCharts'

export const DotiScreen = () => {
    const itemsSpacing = 16
    const [listView, setListView] = useState(false)
    const containerWidth = listView ? '100%' : '50%'

    return (
        <ScrollView style={{ flex: 1, backgroundColor: '#F1F2FF' }}>
            <View style={{ width: '100%', flexDirection: 'row', paddingHorizontal: 12, paddingVertical: 16 }}>
                <Image source={require('../../../assets/doti/doti.png')} style={{ width: 44, height: 44 }} />
                <View style={{ flex: 1, marginStart: 12, marginTop: 5 }}>
                    <Text style={{ fontSize: 15, fontWeight: '700', color: theme.colors.textPrimary }}>Hola, Usuario!</Text>
                    <Text style={{ fontSize: 13, fontWeight: '400', color: theme.colors.darkGray, marginTop: 4 }}>¿En que puedo ayudarte?</Text>
                </View>

                <TouchableOpacity style={{ padding: 8, borderRadius: 12, borderWidth: 1, borderColor: '#E1E3FF', marginEnd: 12 }}>
                    <Image source={require('../../../assets/doti/chats.png')} style={{ width: 24, height: 24 }} />
                </TouchableOpacity>
                {/* ListButton */}
                <TouchableOpacity
                    onPress={() => setListView(true)}
                    style={[
                        {
                            padding: 8,
                            borderTopStartRadius: 12,
                            borderBottomStartRadius: 12,
                            borderWidth: 1,
                            borderRightWidth: 0,
                            borderColor: '#E1E3FF',
                        },
                        listView && { backgroundColor: '#E1E3FF' },
                    ]}
                >
                    <Image
                        source={require('../../../assets/doti/cardsthree.png')}
                        style={[{ width: 24, height: 24, tintColor: 'black' }, listView && { tintColor: theme.colors.colorPrimary }]}
                    />
                </TouchableOpacity>
                {/* GridButton */}
                <TouchableOpacity
                    onPress={() => setListView(false)}
                    style={[
                        {
                            padding: 8,
                            borderTopEndRadius: 12,
                            borderBottomEndRadius: 12,
                            borderWidth: 1,
                            borderLeftWidth: 0,
                            borderColor: '#E1E3FF',
                            marginEnd: 4,
                        },
                        !listView && { backgroundColor: '#E1E3FF' },
                    ]}
                >
                    <Image
                        source={require('../../../assets/doti/squarefour.png')}
                        style={[{ width: 24, height: 24, tintColor: 'black' }, !listView && { tintColor: theme.colors.colorPrimary }]}
                    />
                </TouchableOpacity>
            </View>
            <View style={{ flexDirection: listView ? 'column' : 'row', margin: itemsSpacing }}>
                <View style={[{ width: containerWidth, gap: itemsSpacing, paddingEnd: itemsSpacing / 2 }, listView && { paddingEnd: 0 }]}>
                    <TasksCard
                        data={[
                            'Reforzar ejecución en zona GBA',
                            'Estás 6 tiendas abajo de lo que es el mes anterior',
                            'Aún no te capacitaste en el curso del mes.',
                        ]}
                    />
                    {/* Se agrega el padding 0 pq con la medidas de los progress, se empujan de mas los items */}
                    <Card style={{ flexDirection: listView ? 'row' : 'column', paddingHorizontal: 5 }}>
                        {/* Contenedores para dinamico */}
                        <View style={{ flex: 1, minWidth: 0 }}>
                            <CircleStatCard title='Engagement General' value={80} showCard={false} />
                        </View>
                        {!listView && <View style={[{ height: 20, width: 0 }]} />}
                        <View style={{ flex: 1, minWidth: 0 }}>
                            <CoursesCard completed={3} total={8} showCard={false} />
                        </View>
                        {!listView && <View style={[{ height: 20, width: 0 }]} />}
                        <View style={{ flex: 1, minWidth: 0 }}>
                            <CircleStatCard title='Cumplimiento cursos' value={80} showCard={false} progressColor='#E51D0D' />
                        </View>
                    </Card>
                    <LineChartCard title={'Usuarios activos en el mes'} value={145} data={LineChartData} />
                </View>

                <View
                    style={[
                        { width: containerWidth, gap: itemsSpacing, paddingStart: itemsSpacing / 2 },
                        listView && { paddingStart: 0, paddingTop: itemsSpacing },
                    ]}
                >
                    <DeadlineCard
                        title='Deadline objetivos'
                        value={10}
                        description={'Días para finalizar'}
                        styles={listView ? { alignItems: 'center' } : undefined}
                    />
                    <CircleStatCard title='Tiendas visitadas vs programadas' value={85} change={32} />

                    <DeadlineCard
                        title='Objetivos cumplidos'
                        value='14'
                        change={-10}
                        description='vs semana anterior'
                        descriptionColor='#7B7B7B'
                        styles={listView ? { alignItems: 'center' } : undefined}
                    />
                    <OpportunityCard
                        title='¿Qué usuarios tienen oportunidades de mejora en tiendas?'
                        data={[
                            { name: 'Nicolás Sosa', percent: 42 },
                            { name: 'Brenda Ayala', percent: 30 },
                            { name: 'Sofia Fiorelli', percent: 25 },
                            { name: 'Ailen Diaz', percent: 20 },
                            { name: 'Lucas Reyes', percent: 12 },
                        ]}
                    />
                </View>
            </View>

            <SimpleDataBarChartCard
                title={'Objetivos cumplidos en los últimos 6 meses'}
                data={monthlydata}
                styles={{ marginHorizontal: itemsSpacing }}
            />
            <ComparisonBarChart
                styles={{ margin: itemsSpacing }}
                title={'Detalle de formularios y checkines en los últimos 3 meses'}
                data={ComparisonChartData}
            />
            <VerticalStackedBars
                styles={{ marginHorizontal: itemsSpacing, marginBottom: itemsSpacing * 2 }}
                title={'Cursos realizados vs cursos aprobados por rol'}
                data={verticalData}
            />
        </ScrollView>
    )
}

export const TasksCard = ({ data }) => {
    return (
        <Card>
            {data.map((item, index) => (
                <View key={index} style={{ flexDirection: 'row', marginBottom: index != data.length - 1 ? 8 : 0 }}>
                    <Text
                        style={{
                            fontWeight: '700',
                            color: theme.colors.colorPrimary,
                            marginRight: 6,
                        }}
                    >
                        {index + 1}.
                    </Text>

                    <Text style={{ flex: 1, color: theme.colors.textPrimary, fontWeight: '400' }}>{item}</Text>
                </View>
            ))}
        </Card>
    )
}

export const DeadlineCard = ({ title, value, description, change = null, descriptionColor = theme.colors.colorPrimary, styles }) => {
    return (
        <Card style={styles}>
            <Text
                style={{
                    fontSize: 15,
                    fontWeight: '600',
                    marginBottom: 10,
                    color: '#383838',
                }}
            >
                {title}
            </Text>

            <Text
                style={{
                    fontSize: 42,
                    fontWeight: '700',
                    color: '#5758FF',
                }}
            >
                {value}
            </Text>

            <Text
                style={{
                    marginTop: 0,
                    fontSize: 15,
                }}
            >
                {change && (
                    <Text
                        style={{
                            color: change > 0 ? 'green' : 'red',
                            fontWeight: '600',
                        }}
                    >
                        {change > 0 ? `+${change}% ` : `${change}% `}
                    </Text>
                )}
                <Text style={{ color: descriptionColor, fontWeight: '400' }}>{description}</Text>
            </Text>
        </Card>
    )
}

export const CircleStatCard = ({
    title,
    value,
    subtitle,
    change,
    showCard = true,
    progressColor = theme.colors.colorPrimary,
    unfilledColor = '#D0D2E7',
}) => {
    let Parent = Card
    if (showCard === false) Parent = View
    const progressText = `${value.toFixed(0)}%`
    const percentage = value / 100
    return (
        <Parent>
            <View style={{ alignItems: 'center', marginBottom: 10 }}>
                {/* Círculo (simplificado) */}

                <Progress.Circle
                    size={88}
                    progress={percentage}
                    showsText={true}
                    formatText={(progress) => progressText}
                    textStyle={{
                        fontSize: 22,
                        fontWeight: '700',
                    }}
                    thickness={6}
                    color={progressColor}
                    unfilledColor={unfilledColor}
                    borderWidth={0}
                    strokeCap='round'
                />
            </View>

            <Text
                style={{
                    textAlign: 'center',
                    fontSize: 15,
                    fontWeight: '600',
                    color: '#3A3A3A',
                    marginBottom: change ? 6 : 0,
                }}
            >
                {title}
            </Text>

            {change ? (
                <Text
                    style={{
                        textAlign: 'center',
                        color: change > 0 ? 'green' : 'red',
                        fontWeight: '600',
                    }}
                >
                    {change > 0 ? `+${change}%` : `${change}%`}
                    <Text style={{ color: '#7B7B7B', fontWeight: '400' }}> vs semana anterior</Text>
                </Text>
            ) : null}

            {subtitle && <Text style={{ textAlign: 'center', color: '#7B7B7B' }}>{subtitle}</Text>}
        </Parent>
    )
}

export const CoursesCard = ({ completed = 0, total = 0, showCard = true }) => {
    let Parent = Card
    if (showCard === false) Parent = View
    let value = 0
    let percentage = 0
    if (total > 0) {
        value = (completed * 100) / total
    }
    percentage = value / 100
    const progressText = completed + ' de ' + total
    return (
        <Parent>
            <View style={{ alignItems: 'center', flex: 1 }}>
                <Progress.Circle
                    size={88}
                    progress={percentage}
                    showsText={true}
                    formatText={(progress) => progressText}
                    textStyle={{
                        fontSize: 20,
                        fontWeight: '700',
                        color: theme.colors.textPrimary,
                    }}
                    thickness={6}
                    color={'#009E4D'}
                    unfilledColor={'#D2EBD7'}
                    borderWidth={0}
                    strokeCap='round'
                />
                {/* <Text style={{ fontSize: 22, fontWeight: '700', color: '#' }}>
                       
                    </Text> */}
                <Text
                    style={{
                        textAlign: 'center',
                        marginTop: 10,
                        fontSize: 15,
                        fontWeight: '600',
                        color: '#3A3A3A',
                        flex: 1,
                    }}
                >
                    {'Cursos completados \neste mes'}
                </Text>
            </View>
        </Parent>
    )
}

export const OpportunityCard = ({ title, data }) => {
    return (
        <Card>
            <Text
                style={{
                    fontSize: 15,
                    fontWeight: '600',
                    color: theme.colors.textPrimary,
                    marginBottom: 8,
                }}
            >
                {title}
            </Text>
            {data.map((item, index) => (
                <View key={index} style={{ marginBottom: 24, flex: 1 }}>
                    <View
                        style={{
                            flexDirection: 'row',
                            justifyContent: 'space-between',

                            alignItems: 'center',
                            width: '100%',
                            marginBottom: 6,
                        }}
                    >
                        <Text
                            style={{
                                fontSize: 15,
                                color: '#1A1A1A',
                                maxWidth: '60%',
                            }}
                            ellipsizeMode='tail'
                            numberOfLines={1}
                        >
                            {item.name}
                        </Text>

                        <View
                            style={{
                                flexDirection: 'row',
                                alignItems: 'center',
                                gap: 0,
                            }}
                        >
                            {item.percent && item.percent < 40 && <MaterialCommunityIcons name='alert' size={18} color='#E54335' />}
                            <Text
                                style={{
                                    fontSize: 16,
                                    fontWeight: '600',
                                    color: item.percent < 40 ? '#E54335' : theme.colors.colorPrimary,
                                }}
                            >
                                {item.percent}%
                            </Text>
                        </View>
                    </View>

                    {/* Barra de progreso */}
                    <View
                        style={{
                            height: 8,
                            backgroundColor: '#D8D6E5',
                            borderRadius: 8,
                            flex: 1,
                        }}
                    >
                        <View
                            style={[
                                {
                                    height: 8,
                                    backgroundColor: item.percent < 40 ? '#E54335' : theme.colors.colorPrimary,
                                    borderRadius: 8,
                                },
                                { width: `${item.percent}%` },
                            ]}
                        />
                    </View>
                </View>
            ))}
        </Card>
    )
}

const monthlydata = [
    { value: 100, label: 'JUL' },
    { value: 85, label: 'AGO' },
    { value: 75, label: 'SEP' },
    { value: 50, label: 'OCT' },
    { value: 15, label: 'NOV' },
    { value: 80, label: 'DIC' },
]
const LineChartData = [{ value: 20 }, { value: 35 }, { value: 40 }, { value: 50 }, { value: 45 }, { value: 120 }, { value: 140 }]

const ComparisonChartData = [
    { label: 'SEP', a: 200, b: 400 },
    { label: 'OCT', a: 600, b: 350 },
    { label: 'NOV', a: 800, b: 970 },
]
const verticalData = [
    {
        label: 'Director',
        stacks: [
            { value: 12, color: '#6A5AE0' }, // Sí
            { value: 21, color: '#4E8EF5' }, // No
        ],
    },
    {
        label: 'Supervisor',
        stacks: [
            { value: 19, color: '#6A5AE0' },
            { value: 30, color: '#4E8EF5' },
        ],
    },
    {
        label: 'Ejecutivo',
        stacks: [
            { value: 14, color: '#6A5AE0' },
            { value: 15, color: '#4E8EF5' },
        ],
    },
]
